module.exports = __webpack_public_path__ + "static/media/footer_green.1ac1d074.png";